import { useCallback } from "react";
import { Breadcrumbs } from "~/components/UI";
import MDESMerchants from "./Components/MDESMerchants";
import { useTranslation } from "react-i18next";

/**
 * @namespace MDESMerchants
 */

const MDESMerchantsPage = () => {
  const { t } = useTranslation();

  const getBreadcrumbs = useCallback(() => {
    return [
      { label: t("title.catalogs") },
      { label: t("title.mdesMerchants") },
    ];
  }, [t]);

  return (
    <>
      <Breadcrumbs links={getBreadcrumbs()} />
      <MDESMerchants />
    </>
  );
};

export default MDESMerchantsPage;
